<div
  class="fdk-alert fdk-alert--{{ variant }}"
  role="alert">
  <fdk-icon
    class="fdk-alert__icon"
    [name]="variant"
    [size]="24" />

  <div class="fdk-alert__content">
    <div class="fdk-alert__title">{{ title }}</div>
    <div class="fdk-alert__description">{{ description }}</div>
  </div>
</div>
